// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2acIg","content":"styles_content__XQTyq","selectAll":"styles_selectAll__26HbX"};